export const alignRight = {
  textAlign: 'right',
}

export const container = {
  backgroundColor: '#1B1C1D',
  bottom: 0,
  paddingTop: 80,
  position: 'fixed',
  top: 0,
}
